import { login } from '@/api'
import { langs } from '@/utils/data'
import { loadLanguageAsync } from '@/utils/i18n'
import sensors from 'sa-sdk-javascript';
import { registerLaunchParams } from '@/utils/launchParams';

let pendingLogin = null

export default {
  namespaced: true,
  state: {
    deviceInfo: {},
    userInfo: {},
    lang: window.localStorage.getItem('lang')
  },

  mutations: {
    setDeviceInfo(state, deviceInfo) {
      // 通过ua判断是否为ios
      const isIos = /iPhone|iPad/.test(window.navigator.userAgent)
      if (!isIos) {
        deviceInfo && (deviceInfo.bottomHeight = 0)
      }
      state.deviceInfo = deviceInfo
    },

    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },

    setLang(state, lang) {
      state.lang = lang
    }
  },

  actions: {
    async login({ state, commit }) {
      if (state.userInfo?.id) {
        return state.userInfo
      }

      let userInfo = window.sessionStorage.getItem('userInfo')
      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo)
        } catch (e) {
          console.error(e)
          userInfo = null
        }
      }

      if (userInfo?.id) {
        commit('setUserInfo', userInfo)
        sensors.login(userInfo.id)
        return userInfo
      }

      if (pendingLogin) {
        return pendingLogin
      }

      pendingLogin = (async () => {
        try {
          const ttLoginPromise = new Promise((resolve, reject) => {
            window.TTMinis.login((response) => {
              console.log("login response", response)
              const code = response?.authResponse?.code
              if (code) {
                resolve(code)
              } else {
                reject(response)
              }
            })
          })

          const code = await ttLoginPromise
          // const code = "Y_jQLWhybp1NwnfNgT-imUL8pTOUBBJwzJY4wpZnf4fEH_DKYxOFgOifIM0MPPOnkudooMZcnrhHXtQuoF20TZELqI5pGOgvn3v1V36FAnGR-mFmwkFGwr7miDcfABPpnbiPYsmYc_FEn82uIZIkGbS2qOkNg6RTsdvENqB8itovaw9XW05korQ6kAsVERIKzD84ooiToJ3JUngQfcq1npB7PcCLVptw-X5hcA3Q61wmuJRWILnxDUioEas%2Av%216184.s1"
          

          const res = await login({
            accessToken: code,
            loginType: "tiktok"
          })

          if (res?.data) {
            commit('setUserInfo', res.data)
            window.sessionStorage.setItem('userInfo', JSON.stringify(res.data))
            sensors.login(res.data.id)
            return res.data
          }

          // this.$toast('loginFailed')
          console.log("login failed", res)
          return null
        } catch (error) {
          // this.$toast('loginFailed')
          console.log("login failed", error)
          return null
        }
      })()

      try {
        return await pendingLogin
      } finally {
        pendingLogin = null
      }
    },

    logout({ commit }) {
      commit('setUserInfo', {})
      window.sessionStorage.removeItem('userInfo')
    },

    initLaunchParams() {
      registerLaunchParams()
    },

    async setLang({ commit }, lang) {
      console.log('setLang', lang)
      const langItem = langs.find(item => item.value === lang)
      const langSet = langItem?.value || "en"
      commit('setLang', langSet)
      window.localStorage.setItem('lang', langSet)
      await loadLanguageAsync(langSet)
    }
  }
}
